<template>
  <div id="EvaluationList">
    <div class="list_view list_flex">
      <a-menu style="width: 200px" mode="vertical" :selectedKeys="defaultData" @click="handleClick">
        <a-menu-item key="1" v-if="teacherAdmin.jw_enable">
          <router-link to="/evaluationList/taskManage">教育局任务管理</router-link>
        </a-menu-item>
        <a-menu-item key="2" v-if="teacherAdmin.jw_enable">
          <router-link to="/evaluationList/taskHistory">教育局任务报告</router-link>
        </a-menu-item>
        <a-sub-menu v-if="teacherAdmin.kaitong && teacherAdmin.jw_enable">
          <template slot="title"><span></span></template>
        </a-sub-menu>
        <a-menu-item key="3" v-if="teacherAdmin.kaitong">
          <router-link to="/evaluationList/distributionStu">学生测评</router-link>
        </a-menu-item>
        <a-menu-item key="4" v-if="teacherAdmin.kaitong">
          <router-link to="/evaluationList/evaluationProgress">测评进度</router-link>
        </a-menu-item>
        <a-menu-item key="5" v-if="teacherAdmin.kaitong">
          <router-link to="/evaluationList/reportList">报告中心</router-link>
        </a-menu-item>
        <!-- <a-sub-menu v-if="teacherAdmin.kaitong">
          <template slot="title"><span></span></template>
        </a-sub-menu> -->
        <!-- <a-menu-item key="6">
          <router-link to="/evaluationList/gameReportList">游戏报告</router-link>
        </a-menu-item> -->
        <a-sub-menu v-if="user.role_id === 1">
          <template slot="title"><span></span></template>
        </a-sub-menu>
        <a-menu-item v-if="user.role_id === 1" key="7">
          <router-link to="/evaluationList/teacherTest">教师测评</router-link>
        </a-menu-item>
        <a-menu-item v-if="user.school_id === 9">
          <router-link to="/evaluationList/qingXuTest">情绪状态测评</router-link>
        </a-menu-item>
      </a-menu>
      <div class="list_con">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  export default {
    name: 'EvaluationList',
    data () {
      return {
        user: JSON.parse(sessionStorage.getItem('userInfo'))
      }
    },
    computed: {
      ...mapState([
        'teacherAdmin',
        'defaultData'
      ])
    },
    methods: {
      ...mapMutations([
        'setDefaultData'
      ]),
      handleClick({item, key}) {
        this.setDefaultData([key])
        console.log('click ', item)
      },
      publiceFun () { // 导航下的子路由
        if (this.teacherAdmin.jw_enable) {
          this.setDefaultData(['1'])
          this.$router.push('/evaluationList/taskManage')
        }
        if (this.teacherAdmin.kaitong && !this.teacherAdmin.jw_enable) {
          this.setDefaultData(['3'])
          this.$router.push('/evaluationList/distributionStu')
        }
        if (!this.teacherAdmin.kaitong && !this.teacherAdmin.jw_enable) {
          this.setDefaultData(['5'])
        }
      }
    },
    watch: {
      $route (to) {
        if(to.path === '/evaluationList') {
          this.publiceFun()
        }
      }
    },
    mounted () {
      this.publiceFun()
    }
  }
</script>

<style>
  #EvaluationList {
    width: 100%;
    height: 100%;
  }
  #EvaluationList .list_flex {
    display: flex;
  }
  #EvaluationList .list_view {
    width: 100%;
  }
  #EvaluationList .list_view .list_con {
    flex: 1;
    padding: 32px 0px 0px 24px;
    box-sizing: border-box;
  }
  .ant-menu {
    background-color: transparent;
    padding-top: 28px;
  }
  .ant-menu-vertical {
    border: none;
  }
  .ant-menu-item:hover {
    background: #F5F5F5!important;
  }
  .ant-menu-item:hover>a, .ant-menu-item-selected > a  {
    color: #25B864;
  }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background: transparent;
  }
  .ant-menu-submenu, .ant-menu-submenu div {
    height: 5px!important;
    line-height: 0px!important;
    margin-bottom: 13px;
  }
  .ant-menu-submenu span {
    display: inline-block;
    width: 25px;
    height: 1px;
    background: #E8E8E8;
  }
  .ant-menu-submenu i {
    display: none;
  }
  .ant-progress-status-success .ant-progress-bg {
    background: #25B864;
  }
  .ant-progress-status-success .ant-progress-text {
    color: #25B864;
  }
  .ant-tabs-ink-bar {
    background: #51BF94
  }
</style>
